import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36')
];

export const server_loads = [];

export const dictionary = {
		"/books": [5],
		"/debug": [6],
		"/demo_settings": [7],
		"/history/date": [8,[2]],
		"/history/date/[date]": [9,[2]],
		"/history/isbn": [10,[2]],
		"/history/isbn/[isbn]": [11,[2]],
		"/history/notes": [12,[2]],
		"/history/notes/archive/[id]": [14,[2]],
		"/history/notes/[date]": [13,[2]],
		"/history/warehouse": [15,[2]],
		"/history/warehouse/[warehouseId]": [16,[2,3]],
		"/history/warehouse/[warehouseId]/[from]": [17,[2,3]],
		"/history/warehouse/[warehouseId]/[from]/[to]/[[noteType]]": [18,[2,3]],
		"/inventory": [19,[4]],
		"/inventory/inbound": [20,[4]],
		"/inventory/inbound/[id]": [21,[4]],
		"/inventory/warehouses": [22,[4]],
		"/inventory/warehouses/[id]": [23,[4]],
		"/load_error": [24],
		"/orders/customers": [25],
		"/orders/customers/[id]": [26],
		"/orders/suppliers": [27],
		"/orders/suppliers/orders": [30],
		"/orders/suppliers/orders/[id]": [31],
		"/orders/suppliers/reconcile/[id]": [32],
		"/orders/suppliers/[id]": [28],
		"/orders/suppliers/[id]/new-order": [29],
		"/outbound": [33],
		"/outbound/[id]": [34],
		"/settings": [35],
		"/stock": [36]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = true;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';